import React, {useState} from "react";
//import ProgressBar from 'react-bootstrap/ProgressBar'
import "../../../Styles/certifications.css";

const Certification = ({ course }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleDescription = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <div className="o-cont-certificate">
      <div className="row">
        <p className="col-sm-8">
          <strong>{course.name}</strong>
        </p>
        <p className="col-sm-4 o-date-certificate">{course.completionDate}</p>
      </div>

      <div className="o-platform">
        <p>{course.platform}</p>
      </div>
      <div className="o-platform">
        <p>
          <i>Completion Date:&nbsp;</i>
        </p>
        <p>{course.completionDate}</p>
      </div>
      {course.duration ? (
        <div className="o-platform">
          <p>
            <i>Duration:&nbsp;</i>
          </p>
          <p>{course.duration}</p>
        </div>
      ) : null}
      <div className={`course-description ${isExpanded ? "expanded" : ""}`}>
        <p>{course.briefDescription}</p>
      </div>
      <span className="view-more" onClick={toggleDescription}>
        {isExpanded ? "View Less" : "View More"}
      </span>
      <a href={course.certificateLink}>🔗 View Certificate</a>
    </div>
  );
};
export default Certification;
